import { useMemo } from 'react';
import { useQuery } from '@common-fe/common-fe';

import { api } from '@/api';
import { ERRORS_CODE } from '@/common/constants';
import { API_URL } from '@/dtos';

import {
  AutoInvestmentStatus,
  InvestmentRiskModel,
  InvestmentStatus,
  InvestmentStatusPayload,
  InvestmentType,
} from '../EnrollmentInvestments.types';

interface ResponseDTO {
  account_id?: number;
  employee_id?: number;
  status: InvestmentStatus;
  type: InvestmentType;
  risk_tolerance_model: InvestmentRiskModel;
  investment_balance: 0;
  plan_investment_threshold: 0;
  auto_invest_scheduling_status: AutoInvestmentStatus;
  amount_to_keep: 0;
}

const useGetInvestmentsStatusQuery = (employeeId: string) => {
  const { data, isLoading, error } = useQuery([API_URL.INVESTMENTS_INVESTMENT_STATUS, employeeId], () =>
    api.get<ResponseDTO>(API_URL.INVESTMENTS_INVESTMENT_STATUS, {
      params: {
        employee_id: employeeId,
      },
    })
  );

  const formatted = useMemo((): InvestmentStatusPayload | null => {
    const currentData = data?.data;
    if (!currentData) {
      return null;
    }
    return {
      accountId: `${currentData?.account_id || ''}`,
      employeeId: `${currentData?.employee_id || ''}`,
      status: currentData!.status,
      type: currentData!.type,
      riskToleranceModel: currentData!.risk_tolerance_model,
      investmentBalance: currentData!.investment_balance,
      planInvestmentThreshold: currentData!.plan_investment_threshold,
      autoInvestmentStatus: currentData!.auto_invest_scheduling_status,
      amountToKeep: currentData!.amount_to_keep,
    };
  }, [data?.data]);
  const isNotFound = useMemo(() => {
    // @ts-ignore
    return error?.status === ERRORS_CODE.NOT_FOUND;
  }, [error]);

  return {
    isNotFound,
    data: formatted,
    isLoading,
  };
};
export default useGetInvestmentsStatusQuery;
